import React from "react";
const Red = (props) => {
  const { children } = props;
  return <span className="text-mbd-primary">{children}</span>;
};

export default Red;
